import React,{ useState,useEffect, useCallback } from "react";
import AxiosFetchData from "../pages/AxiosFetchData";
import { useNavigate } from 'react-router-dom';
import ConfirmationButton from '../components/ConfirmationButton';
import Helper from "../pages/Helper";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem from '@mui/material/MenuItem';
export const usePOHook = (id) =>{
    const [rows, setRows] = useState([]);
    const Navigate = useNavigate();
      const [statusList, setStatusList] = useState([]);
      const [print, setPrint] = useState(false);
      const [productList, setProductList] = useState([]);
    //   const [content, setContent] = useState('');
    //   const [dataInvoice, setDataInvoice] = useState({});
    //   const [html, setHtml] = useState('');
    //   const [total, setTotal] = useState(0);
    //   const [customer, setCustomer] = useState([]);
    //   const [tipe, setTipe] = useState('');
      const [anchorEl, setAnchorEl] = React.useState(null);
      const [selectedData, setSelectedData] = React.useState({});
      const open = Boolean(anchorEl);
      const [message, setmessage] = useState('');
      const [errortipe, seterrortipe] = useState('');
      const [roleAccess, setRoleAccess] = useState([]);

      const handleClick = (event,data) => {
        setSelectedData(data)
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
    
    
    var result = "";

    const fetchData = useCallback(async () => {
        try {
         
           const response = await AxiosFetchData.get(`GetPO/${id}`).refreshToken(Navigate,"worklist");
           if(response){
              setRows(response.data); // Update rows with project data
              setRoleAccess(response.roleaccess)
              // Add row numbers to the rows
              const rowsWithRowNumbers = response.data.map((row, index) => ({
                ...row,
                rowNumber: index + 1, 
                
              }));
              setRows(rowsWithRowNumbers);
           }
        
        } catch (error) {
          setmessage(error.message);
          seterrortipe('errorlog')
          
        }
      },[id]);

    useEffect(() => {
        fetchData(); 
    }, [fetchData]); 

    const columns = [
      { field: 'rowNumber', headerName: 'No.', width: 80 },
      { field: 'quotation_id', headerName: 'Code', width: 150 },
      { field: 'quotation_date', headerName: 'Date', width: 100 },
      { field: 'customername', headerName: 'Customer', width: 280 },
      { field: 'subject', headerName: 'Subject', width: 250 },
    //   { field: 'status', headerName: 'Status', width: 150 },
       
      {
        field: 'actions',
        headerName: '',
        width: 160,
        renderCell: (params) => (
          <>
          <Button
            id={"basic-button" + params.row.rowNumber}
            aria-controls={open ? 'basic-menu' + params.row.rowNumber : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={(evt) => handleClick(evt, params.row)}
          >
            <MoreVertIcon sx={{ fontSize: 30 }}/>
          </Button>
     
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
             <MenuItem style={{width:100}}  onClick={() => selectedData.type == 1  ? (Navigate(`/AddPO/${id}/${selectedData.id}/Edit${Helper.SetReturnUrl()}`)) : (Navigate(`/AddPO/${id}/${selectedData.id}/Detail${Helper.SetReturnUrl()}`))} >{selectedData.type == 1 ? "EDIT" : "DETAIL"}</MenuItem>
            {/* <MenuItem style={{width:100}}  onClick={() => selectedData.type == 1  ? (Navigate(`/AddPO/${id}/${selectedData.id}${Helper.SetReturnUrl()}`)) : (Navigate(`/AddPO/${id}/${selectedData.id}${Helper.SetReturnUrl()}`))} >{selectedData.type == 1 ? "EDIT" : "DETAIL"}</MenuItem> */}
            {/* <MenuItem style={{width:100}}  onClick={() => Navigate(`/RAK/${selectedData.id}${Helper.SetReturnUrl()}`)} >RAK</MenuItem>
            <MenuItem onClick={() => Navigate(`/InvoiceList/${selectedData.id}${Helper.SetReturnUrl()}`)}>INVOICE</MenuItem> */}
    {/* 
            <MenuItem    onClick={() => handleEdit(selectedData.id)} >EDIT</MenuItem>
            <MenuItem    onClick={() => handlePrintInvoice(selectedData.id)} >PRINT INVOICE</MenuItem>
            <MenuItem    onClick={() => handlePrintKwitansi(selectedData.id)} >PRINT KWINTASI</MenuItem> */}
          </Menu>
          
          
          <ConfirmationButton classname='btn btn-primary mr-2' text="Do you want delete this data?" type="button" onClick={() => handleDelete(params.row.id)} title="delete" disabled={roleAccess.DELETE==true ? (params.row.type=='1' ? false : true) : !roleAccess.DELETE}>
              <DeleteIcon sx={{ fontSize: 10 }}/> Delete
          </ConfirmationButton>
          </>
          
        ),
    },
    ];

    const [filterModel, setFilterModel] = React.useState({
      items: [],
      quickFilterExcludeHiddenColumns: true,
      quickFilterValues: [''],
    });
    
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
    
    function AddProjectData() {
      Navigate(`/AddPO/${id}/0/ADD${Helper.SetReturnUrl()}`);
     
    }
    
    function AddInvoice() {
    
        Navigate(`/InvoiceListV3/${id}/${Helper.SetReturnUrl()}`);
      
    }

    const handleDelete = useCallback(async (projectId) => {
     
      try {
        
        const response = await AxiosFetchData.delete(`DeletePO/${projectId}`).refreshToken(Navigate,"worklist");
       
        if(response){
          await fetchData();
          setmessage(response.data)
        }
        
      } catch (error) {
        setmessage(error.message)
        seterrortipe('errorlog')
        //console.error('Error deleting project:', error);
      }
     
    },[]);
 
    return {message,setmessage,errortipe,seterrortipe,AddProjectData,AddInvoice,columns,setFilterModel,columnVisibilityModel,setColumnVisibilityModel,rows}
}